import { type } from 'os';
import { Data } from './data';

export class Admission extends Data {

    
    cycle;
    admissibilite;
    ecole;
    formations;
    labelcycle;
    mois_rentree;
    niveau_requis;
    faculte;
    labelfaculte;
    

    constructor() {
        super();
        this.formations = [];
    }

    
    
   
  }